var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "product-status",
    class: [("product-status_" + (_vm.size))],
    on: {
      "click": function ($event) {
        return _vm.$emit('click');
      }
    }
  }, [_vm.title ? _c('span', {
    staticClass: "product-status__status-title"
  }, [_vm._v(_vm._s(_vm.title))]) : _vm._e(), _vm._v(" "), _vm.icon ? _c('div', {
    staticClass: "product-status__icon",
    class: [[("product-status__icon_" + (_vm.getClass(_vm.code)))]]
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "product-status__title",
    class: [[("product-status__title_" + (_vm.getClass(_vm.code)))]]
  }, [_vm.link && (_vm.code === 'IN_STOCK' || _vm.code === 'FEW') ? _c('span', [_vm._v("\n      " + _vm._s(_vm.value) + "\n    ")]) : _vm.code === 'NOT_AVAILABLE' ? _c('span', [_vm._v(_vm._s('Распродан'))]) : _vm.code === 'PRE_ORDER' ? _c('span', [_vm._v(_vm._s('Предзаказ'))]) : _vm._e()]), _vm._v(" "), _vm.rightIcon ? _c('div', {
    staticClass: "product-status__right-icon",
    class: [[("product-status__right-icon_" + (_vm.getClass(_vm.code)))]]
  }) : _vm._e()]);
}
var staticRenderFns = []

export { render, staticRenderFns }